import { Component } from '~/types'

const component: Component = ref => {
  if (!ref.video) return

  ref.video.forEach((container: HTMLElement) => {
    const video = container.querySelector('video')
    if (!video) return

    // Ensure autoplay videos start playing after Barba navigation
    if (video.hasAttribute('autoplay') && video.paused) {
      video.play().catch(() => {
        // Autoplay may fail due to browser policy - silent fail is acceptable
      })
    }
  })
}

export default component
